import { Dispatch } from "redux";
import { getIdentityProviderDetailsReferenceDataRequest } from "@requests/identity-provider";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";
import { IdentityProviderDetailsReferenceData } from "@idw-types/state/identity-provider-details-state";

export const getIdentityProviderDetailsReferenceDataReduxRequest = (dispatch: Dispatch, setIsLoadingAction: (isLoading: boolean) => any, setIdentityProviderDetailsReferenceDataAction: (referenceData: IdentityProviderDetailsReferenceData) => any) => async () => {
    dispatch(setIsLoadingAction(true));
    const { data, error } = await getIdentityProviderDetailsReferenceDataRequest();
    if (data) {
        dispatch(setIdentityProviderDetailsReferenceDataAction(data));
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.referenceData.error.title,
                resources.requests.referenceData.error.message
            );
        }
        dispatch(setIsLoadingAction(false));
    }
};